import React, {useEffect, useState} from 'react';
import Cookies from 'js-cookie';
import DropdownMenu from "@/commons/utils/Dropdown/DropdownMenu";
import DropdownElement from "@/commons/utils/Dropdown/DropdownElement";
import ApiInterface from "@/commons/api/ApiInterface";
import {getUserHead, getUserSkin} from "@/commons/utils/others/Users";
import {useUser} from "@/contexts/UserContext";
import styles from '../Header.module.css';
import dropdownStyles from '@/commons/utils/Dropdown/DropdownMenu.module.css';
import Redirects from "@/commons/utils/Redirects";

const AccountHeader = () => {
    const {isLogged, isStaff, userLoadingComplete, minecraftData, accountData} = useUser();
    const [finalSkin, setFinalSkin] = useState(null);
    const [finalCompleteSkin, setFinalCompleteSkin] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);

    const [roleImage, setRoleImage] = useState(null);

    useEffect(() => {
        if (isLogged && minecraftData?.uuid) {
            getUserHead(minecraftData.uuid, accountData.username).then(setFinalSkin);
            getUserSkin(minecraftData.uuid, accountData.username).then(setFinalCompleteSkin);
        } else {
            getUserHead("test", "test").then(setFinalSkin);
            getUserSkin("test", "test").then(setFinalCompleteSkin);
        }
        if(accountData) {
            loadImage()
        }
        if(isLogged){
            loadNotifications();
        }
    }, [isLogged, minecraftData, accountData]);

    let loadImage = async () => {
        let image = await ApiInterface.loadRoleImage(accountData.staffGroup.id);
        setRoleImage(image);
    }

    const loadNotifications = async () => {
        try {
            const response = await ApiInterface.getUnreadNotifications();
            const data = await response.json();
            setNotifications(data.content || []);
        } catch (e) {
            console.error("Errore caricamento notifiche", e);
        }
    };

    const handleLogout = () => {
        ApiInterface.logout();
    };

    if (!userLoadingComplete) return null;


    return isLogged ? (<>
        <DropdownMenu
            title={<div className={styles.accountImageWrapper}>
                <img src={finalSkin} alt="profile"/>
                {notifications.length > 0 && (
                    <span className={styles.notificationNumber}>{notifications.length}</span>)}
            </div>}
            char=""
            align="right"
            onClose={() => {
                setShowNotificationDropdown(false)
            }}
        >
            <div className={dropdownStyles.customAccountZone}>
                <div
                    style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '10px'}}>
                    <img src={roleImage} alt={"Role Image"}/>
                    <span>{accountData?.username}</span>
                </div>

                <div className={dropdownStyles.customAccountGrid}>
                    <div className={dropdownStyles.customAccountGridItem}>
                        <h4>AREA PERSONALE</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "profile", e)}>
                            Il tuo profilo
                        </DropdownElement>
                        {isStaff && (<DropdownElement onClick={(e) => Redirects.domainSendClick("admin", "", e)}>
                                Sezione Admin
                            </DropdownElement>)}

                        <h4>EBL Reports</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("reports", "", e)}>
                            I tuoi report
                        </DropdownElement>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("reports", "tickets", e)}>
                            Apri un report
                        </DropdownElement>

                        <h4>ALTRO</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "downloads", e)}>
                            I tuoi download
                        </DropdownElement>
                        <DropdownElement onClick={(e) => setShowNotificationDropdown(!showNotificationDropdown)}>
                            Notifiche{notifications.length > 0 ? "(" + notifications.length + ")" : ""}
                        </DropdownElement>
                    </div>

                    <div>
                        <img width={120} src={finalCompleteSkin} alt={"Complete User Skin"}/>
                    </div>
                </div>
                <DropdownElement customClass={dropdownStyles.logoutButton} onClick={handleLogout}>
                    Logout
                </DropdownElement>
            </div>
        </DropdownMenu>

        {/* Notifiche Dropdown separato */}
        {showNotificationDropdown && (<div style={{
                position: 'absolute', zIndex: 1000,
            }}>
                <DropdownMenu title={<></>}
                              char=""
                              align="right"
                              isSubmenu={false}
                              status={showNotificationDropdown}
                              customClass={dropdownStyles.customNotificationDropdown}
                              backgroundColor={"rgba(119, 119, 119, 1)"}>

                    {notifications.length > 0 ? (<DropdownElement onClick={async () => {
                            await ApiInterface.readAll();
                            await loadNotifications();
                        }}>
                            Segna tutte come lette
                        </DropdownElement>) : (<></>)}
                    {notifications.length > 0 ? notifications.map((notif) => (
                        <DropdownElement key={notif.id} onClick={(event) => {
                            ApiInterface.readNotification(notif.id).then(() => Redirects.send(notif.redirect, event));
                        }}>
                            <div>{notif.title}</div>
                        </DropdownElement>)) : (<DropdownElement removeHover={true}>
                            <div>Nessuna notifica</div>
                        </DropdownElement>)}
                    <DropdownElement onClick={() => setShowNotificationDropdown(false)}>
                        Chiudi
                    </DropdownElement>
                </DropdownMenu>
            </div>)}
    </>) : (<DropdownMenu
            title={<div className={styles.accountImageWrapper}>
                <img src={finalSkin} alt="profile"/>
            </div>}
            char=""
            align="right"
        >
            <div className={dropdownStyles.customAccountZone}>
                <div className={dropdownStyles.customAccountGrid}>
                    <div className={dropdownStyles.customAccountGridItem}>
                        <h4>Accesso</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "access#login", e)}>
                            Accedi
                        </DropdownElement>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "access#register", e)}>
                            Registrati
                        </DropdownElement>
                    </div>
                    <div>
                        <img width={120} src={finalSkin} alt={"Basic Avatar"}/>
                    </div>
                </div>
            </div>
        </DropdownMenu>);
};

export default AccountHeader;
